// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2unXr","sendOtp":"AuthorizeToLogin_sendOtp__1rE6j"};